import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  error: {
    color: theme.palette.error.main,
  },
  boxInfo: {
    marginLeft: -8,
    marginRight: 8,
  },
  info: {
    color: theme.palette.info.main,
  },
}))

export default styles
